import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, styled } from '@withjoy/joykit';
import { CloseThick } from '@withjoy/joykit/icons';
export const StyledClearFiltersContainer = styled(Box)<{ disabled: boolean }>``;
export const StyledCloseIconContainer = styled(CloseThick)``;

const contentContainerStyles: StyleSystemProps = {
  height: '100%',
};

const clearFiltersContainerStyles: StyleSystemProps = {
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: 'primary',
  flex: 1,
  _disabled: {
    opacity: 0.4,
  },
};

const spacingStackStyles: StyleSystemProps = {
  borderTopColor: 'mono3',
  borderBottom: 'none',
  borderWidth: '1px',
  borderLeftWidth: 0,
  borderRightWidth: 0,
  borderTopStyle: 'solid',
  marginTop: 5,
  padding: 6,
  marginX: -6,
};

export const styles = {
  contentContainer: contentContainerStyles,
  clearFiltersContainer: clearFiltersContainerStyles,
  spacingStack: spacingStackStyles,
};
